<template>
<div class="adddrawingwrapper">
  <div class="drawinginputs">
    <div class="div-block-39">
      <div class="div-block-40">
        <div class="text-block-22">Edit Item</div><a href="#" class="link-block-6 w-inline-block" @click="$emit('close-edit-item')"><img src="../../static/images/cancel.png" width="32" height="32" class="image-6"></a></div>
      <div class="adddrawinginputs">
        <el-form v-if="formInstance" :model="formInstance" label-position="top">
          <el-form-item label="Item Code" required>
            <el-input v-model="formInstance.model" placeholder="Please enter new item code"></el-input>
          </el-form-item>
          <el-form-item label="Color Spec." required>
          <el-autocomplete
            placeholder="Color Spec."
            v-model="formInstance.color.color" :clearable="true"
            :fetch-suggestions="suggestColor"
            :trigger-on-focus="true"
            @select="selectColor">
          </el-autocomplete>
          </el-form-item>
          <el-form-item label="Color Tag">
            <el-color-picker v-model="formInstance.color.tag"></el-color-picker>
          </el-form-item>
          <el-form-item label="Glide">
              <el-input-number v-model="formInstance.glide" :min="0" label="Glide"></el-input-number>
          </el-form-item>
          <el-form-item label="Handle">
              <el-input-number v-model="formInstance.handle" :min="0" label="Handle"></el-input-number>
          </el-form-item>
          <el-form-item label="Hinge">
              <el-input-number v-model="formInstance.hinge" :min="0" label="Hinge"></el-input-number>
          </el-form-item>
          <el-form-item label="Remark">
            <el-input v-model="formInstance.projectRemark" placeholder="Please enter global memo. for this item"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="adddrawingbuttons">
      <div class="form-warning" v-show="duplicateItem"><i class="material-icons" style="margin-right: 8px;">error</i><span> Duplicated item found, please CHANGE item code OR color to make it unique.</span></div>
      <el-button type="primary" round @click="saveItem" :disabled="formNotValid"> Save</el-button>
    </div>
  </div>
</div>
</template>

<script>
import drawingService from '../../static/js/drawing'

export default {
  name: 'EditItemForm',
  props: ['item', 'projectId'],
  data () {
    return {
      formInstance: this.item,
      originalModel: this.item.model,
      originalColor: this.item.color.color,
      knowledgeBaseReady: false,
      knowledgeBase: {},
      suggestColors: []
    }
  },
  computed: {
    formNotValid: function () {
      return (this.formInstance.model === '' || this.formInstance.color.color === '' || this.duplicateItem)
    },
    duplicateItem: function () {
      if (!this.knowledgeBaseReady) {
        // console.log('KB NOT READY')
        return false
      }
      if (this.originalModel === this.formInstance.model && this.originalColor === this.formInstance.color.color) {
        return false
      }
      let model = this.formInstance.model.toLowerCase()
      let color = this.formInstance.color.color.toLowerCase()
      // console.log(model, color)

      // search item base for duplicate
      for (let currentItem of this.knowledgeBase.itemBase) {
        // console.log('examining item =>', currentItem)
        if (currentItem.model.toLowerCase() === model) {
          // exam if color also match
          let colorId = currentItem.colorId
          // console.log('model match found, examining color id =>', colorId)

          for (let currentColor of this.knowledgeBase.colorBase) {
            // console.log('examining color =>', color)
            if (currentColor.colorId === colorId) {
              let colorFound = currentColor.name.toLowerCase()
              if (color === colorFound) {
                return true
              }
            }
          }
        }
      }
      return false
    }
  },
  mounted: function () {
    this.initColorBase()
  },
  watch: {
    projectId: function () {
      this.initColorBase()
    }
  },
  methods: {
    initColorBase: async function () {
      if (this.projectId && this.projectId !== 'NO_PROJECT_SELECTED') {
        await drawingService.initService(this.projectId)
        // console.log(initResult)
        let knowledgeBase = await drawingService.fetchProjectKnowledgeBase(this.projectId)
        this.knowledgeBase = knowledgeBase
        let colorBase = knowledgeBase.colorBase ? knowledgeBase.colorBase : []
        // console.log(colorBase)
        this.suggestColors = colorBase.map(color => {
          return {
            color: color.name,
            tag: color.tag,
            value: color.name
          }
        })
        this.knowledgeBaseReady = true
      } else {
        this.suggestColors = []
        this.knowledgeBaseReady = false
      }
    },
    saveItem: async function () {
      let itemData = this.formInstance
      itemData.projectId = this.projectId
      itemData.color.name = itemData.color.color
      delete itemData.color.color
      let saveResult = await drawingService.saveEditItem(itemData, this.knowledgeBase)
      if (saveResult) {
        this.$emit('close-edit-item')
        // this.$notify({
        //   title: 'Success',
        //   message: 'Item updated',
        //   type: 'success',
        //   duration: 3000,
        //   offset: 64
        // })
      } else {
        // this.$notify({
        //   title: 'Error',
        //   message: 'Item note saved, please try again',
        //   type: 'error',
        //   duration: 3000,
        //   offset: 64
        // })
      }
    },
    selectColor: function () {
      let inputColor = this.formInstance.color.color
      for (let color of this.suggestColors) {
        if (inputColor === color.color) {
          this.formInstance.color.tag = color.tag
        }
      }
    },
    suggestColor: function (queryString, cb) {
      var colors = this.suggestColors
      var results = queryString ? colors.filter(this.colorFilter(queryString)) : colors
      cb(results)
    },
    colorFilter: function (queryString) {
      return (color) => {
        return (color.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    }
  }
}
</script>

<style scoped>
.form-warning {
  color: #e53935;
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditItemForm.vue